import React, { useEffect } from 'react';
import { Prospect } from '../../shared/types';
import { automoveisStock, historicoManutencao } from '../../shared/data/automoveisData';
import { Car, Wrench, Shield, Calendar, Bell, ChevronRight, CheckCircle2, RefreshCw } from 'lucide-react';

export const AutoApp: React.FC<{ prospect: Prospect }> = ({ prospect }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const myCar = automoveisStock[0];

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4 font-sans text-white">
      <div className="w-[390px] h-[844px] bg-[#09090B] rounded-[2.5rem] relative overflow-hidden border-[12px] border-zinc-800 flex flex-col justify-between">
        
        {/* Header App / Garage Status */}
        <div>
           {/* Top Status Bar */}
           <div className="h-12 flex items-center justify-between px-8 text-xs font-medium pt-2 text-zinc-400">
              <span>10:45</span>
              <div className="flex gap-1.5 items-center">
                 <div className="w-4 h-3 bg-current rounded-sm"></div>
                 <div className="w-3 h-3 bg-current rounded-full"></div>
              </div>
           </div>

           <div className="px-6 pt-2 pb-4">
              <div className="flex justify-between items-center mb-6">
                 <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-red-600 text-white flex items-center justify-center font-black">
                       <Car className="w-5 h-5" />
                    </div>
                    <div>
                       <p className="text-[10px] text-zinc-500 uppercase tracking-widest font-bold">Minha Garagem</p>
                       <h1 className="font-heading font-black text-sm text-white">{prospect.trade_name}</h1>
                    </div>
                 </div>
                 <div className="w-9 h-9 rounded-xl bg-zinc-900 border border-zinc-800 flex items-center justify-center text-zinc-400">
                    <Bell className="w-4 h-4" />
                 </div>
              </div>

              {/* Card Veículo do Cliente - STRICT NO SHADOWS */}
              <div className="bg-zinc-900 border border-zinc-800 p-5 rounded-xl mb-6">
                 <div className="flex justify-between items-start mb-3">
                    <span className="bg-red-600/20 text-red-400 border border-red-500/30 px-2 py-0.5 rounded text-[10px] font-bold uppercase">Garagem Ativa</span>
                    <span className="text-[10px] text-zinc-500 font-mono">ABC-9921</span>
                 </div>
                 <div className="aspect-video rounded-lg overflow-hidden mb-3 border border-zinc-800">
                    <img src={myCar.image} alt={myCar.model} className="w-full h-full object-cover" />
                 </div>
                 <h4 className="font-bold text-sm text-white mb-0.5">{myCar.brand} {myCar.model}</h4>
                 <p className="text-[10px] text-zinc-400 font-mono mb-3">{myCar.version} • {myCar.year}</p>
                 
                 <div className="bg-zinc-950 p-3 rounded-lg border border-zinc-800 flex items-center justify-between text-xs">
                    <span className="text-zinc-400">Valor de Mercado FIPE:</span>
                    <span className="font-black text-emerald-400">R$ 1.220.000</span>
                 </div>
              </div>

              {/* Histórico de Serviços / Manutenção - STRICT NO SHADOWS */}
              <h3 className="font-heading font-bold text-xs uppercase tracking-wider text-zinc-400 mb-3">Histórico de Revisões</h3>
              <div className="space-y-3">
                 {historicoManutencao.map(rec => (
                    <div key={rec.id} className="bg-zinc-900 border border-zinc-800 p-4 rounded-xl flex items-center justify-between">
                       <div className="flex items-center gap-3">
                          <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${rec.status === 'Concluído' ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20' : 'bg-amber-500/10 text-amber-400 border border-amber-500/20'}`}>
                             <Wrench className="w-4 h-4" />
                          </div>
                          <div>
                             <h5 className="font-bold text-xs text-white leading-tight">{rec.service}</h5>
                             <p className="text-[10px] text-zinc-500">{rec.date} • {rec.mileage}</p>
                          </div>
                       </div>
                    </div>
                 ))}
              </div>

           </div>
        </div>

        {/* Footer App */}
        <div className="p-6 bg-zinc-900 border-t border-zinc-800">
           <button className="w-full bg-red-600 text-white py-3 rounded-xl font-black text-xs uppercase tracking-wider border border-red-500 flex items-center justify-center gap-2">
              Agendar Manutenção na Garagem
           </button>
        </div>

      </div>
    </div>
  );
};
